import script from "./main-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./main-menu.vue?vue&type=script&setup=true&lang=js"

import "./main-menu.vue?vue&type=style&index=0&id=a83c2b96&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a83c2b96"]])

export default __exports__